import * as ko from "knockout";
import {IFormData} from "./index";
import {PLEASE_WAIT_MESSAGE, REDIRECTING_MESSAGE} from "../../../constants/Language";
import PromiseRequest from "../../../req/PromiseRequest";
import {IAuthenticationType, IMessageData} from "../../../index";
import {nsLogin} from "../../../util/nsLogin";
import {AuthenticationTypeFlag} from "../../../constants/AuthenticationTypeFlag";
import method_teliafiHtml from './method-teliafi.html?raw';

export let template = method_teliafiHtml;

export class viewModel {

    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private readonly isReady: KnockoutObservable<boolean> = ko.observable(false);
    private readonly req_getauthenticationtypes: PromiseRequest = new PromiseRequest('getauthenticationtypes')
    private authenticationType_telia!: IAuthenticationType;

    constructor(private params: IFormData) {
        this.init()
    }

    private init() {
        this.isReady(false)
        this.messageData({message: PLEASE_WAIT_MESSAGE})
        return this.req_getauthenticationtypes
            .request()
            .then((data: IAuthenticationType[]) => {
                const found = data.find(o => o.flag == AuthenticationTypeFlag.TELIA_FINLAND);
                if (!found) {
                    throw new Error('Telia Finland authentication type not found');
                }
                this.authenticationType_telia = found;
                this.messageData(null)
                this.isReady(true)
            })
    }

    protected onSubmit(): void {
        this.params.isReady(false);
        this.params.messageData({message: REDIRECTING_MESSAGE});
        const orgnr = this.params.selectedOrg().orgnr;
        const redirectUrl = document.location.origin + '/#/resetownpassword';
        const url = nsLogin.getFederatedLoginUrl(this.authenticationType_telia, this.params.selectedOrg().orgnr, redirectUrl)
        window.location.href = url;
    }

    dispose() {
        this.req_getauthenticationtypes.abort();
    }

}
